import React, { useEffect, useMemo, useState } from 'react'
import { SimulatorOfferModel } from '../models/superbit-api-models';
import DropDownIcon from '../components/_DropDownIcon';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setOfferId, setLeadId } from './../app-context/policyProduction'
import { mn } from 'date-fns/locale';


interface LeadOfferContentProps {
    offer: SimulatorOfferModel | null;
    leadsSendMail: () => void;
    sendToWhatsApp: () => void;
    createRider: () => void;
    toggleBtnMenu: () => void;
    ridersSum: any;
    getAuthorizedToDriveName: any;
    insuranceLabel: string;
    emailAddress: string;
    hideCreateRiderOption: boolean;
    leadId: any;
    OpenProd: string;
}

const LeadOfferContent: React.FC<LeadOfferContentProps> = ({
    offer,
    leadsSendMail,
    sendToWhatsApp,
    createRider,
    toggleBtnMenu,
    ridersSum,
    getAuthorizedToDriveName,
    insuranceLabel,
    emailAddress,
    hideCreateRiderOption,
    leadId,
    OpenProd
}) => {
    const dispatch = useDispatch();

    const getNumberOrZero = (int: number | undefined | null) => {
        if (int != null && int != undefined)
            return int;
        return 0;
    }

    const optionsList = useMemo(() => {
        const baseOptions = [
            {
                key: 'sendToEmail',
                label: 'שליחה ללקוח מייל',
                hide: emailAddress === ''
            },
            {
                key: 'sendToWhatsApp',
                label: 'שליחה בוואטס אפ',
                hide: false
            },
            {
                key: 'createRider',
                label: 'יצירת מנוי',
                hide: !hideCreateRiderOption
            }
        ];

        if (offer && offer.vehicle && offer.vehicle.licenseNumber && offer.vehicle.licenseNumber.length > 0) {
            baseOptions.push({
                key: 'openProduction',
                label: OpenProd !== "" && OpenProd === offer.id ? "הצג פוליסה" : "הפקת פוליסה",
                hide: OpenProd !== "" && OpenProd !== offer.id
            });
        }

        return baseOptions;
    }, [offer, OpenProd, emailAddress, hideCreateRiderOption]);



    const onMenuClick = (action: string, value?: string) => {
        console.log(action);
        switch (action) {
            case 'sendToEmail':
                leadsSendMail();
                break;
            case 'sendToWhatsApp':
                sendToWhatsApp();
                break;
            case 'createRider':
                createRider();
                break;

            case 'openProduction':
                openProduction();
                break;

            default:
                break;
        }
        // toggleBtnMenu()
    }

    const openProduction = async () => {

        //set id to state
        if (offer && offer.id) {

            dispatch(setOfferId(offer.id))
            dispatch(setLeadId(leadId))
        }
        // this.props.onProductionClick(this.props.offer);
    }


    if (!offer) {
        return null;
    }

    return (

        <div className="detailsscontent-row flex-centered flex-space-between">

            <div className="cell-price">
                {offer.offerIdentity}
            </div>
            <div className="cell date" style={{ minWidth: 140, width: 140 }}>
                <div className='inner-row'>
                    <span className='title'>
                        ת.יצירה:
                    </span>
                    {" " + moment(offer.createdDate).format('DD-MM-YYYY')}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        ת.תחילה:
                    </span>
                    {" " + moment(offer.startDate).format('DD-MM-YYYY')}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        ת.סיום:
                    </span>
                    {" " + moment(offer.endDate).format('DD-MM-YYYY')}
                </div>
            </div>
            {/* <div className="cell date">
                {moment(offer.startDate).format('DD-MM-YYYY')}
            </div>
            <div className="cell date">
                {moment(offer.endDate).format('DD-MM-YYYY')}
            </div> */}



            <div className="cell-price" style={{ width: 90 }}>
                    <div className='inner-row'>
                        <span className='title' style={{color: 'gray'}}>
                            גיל צעיר:
                        </span>
                        {" " + offer.driverYoungAge}
                    </div>
                    <div className='inner-row'>
                        <span className='title' style={{color: 'gray'}}>
                            וותק צעיר:
                        </span>
                        {" " + offer.driverYoungSeniority}
                    </div>
                    <div className='inner-row'>
                        <span className='title' style={{color: 'gray'}}>
                        גיל עיקרי:
                        </span>
                        {" " + offer.driverMainAge}
                    </div>
                    <div className='inner-row'>
                        <span className='title' style={{color: 'gray'}}>
                            וותק עיקרי:
                        </span>
                        {" " + offer.driverMainSeniority}
                    </div>
            </div>
            
            <div className="cell-price">
                {getAuthorizedToDriveName(offer.authorizedToDrive)}
            </div>
            <div className="pass-insurance">
                {offer.vehicle && offer.vehicle.vehicleSubModel ? (
                    <>
                        <div className='inner-row'>
                            <span className='title'>
                                קוד דגם:
                            </span>
                            {" " + offer.vehicle.modelCode ? offer.vehicle.modelCode : ''}
                        </div>
                        <div className='inner-row'>
                            <span className='title'>
                                רישוי:
                            </span><br />
                            {" " + offer.vehicle.licenseNumber ? offer.vehicle.licenseNumber : ''}
                        </div>
                    </>
                ) : ''}

            </div>

            <div className="cell insurance-company" style={{ minWidth: 'fit-content' }}>
                {offer.insuranceCompany != null ? (
                    <div className='inner-row'>{offer.insuranceCompany.name}</div>
                ) : ""}
                <div className='inner-row'>
                    <span className='title'>
                        ענף:
                    </span>
                    {offer.routeId != null ? offer.routeId : 0}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        מסלול:
                    </span> <br />
                    {offer.routeComment} {offer.additionalDetails && offer.additionalDetails.indexOf('coverage10000\':true')!=-1?"10000":""}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        סוג ביטוח:
                    </span> <br />
                    {insuranceLabel}
                </div>
            </div>
            <div className='pass-insurance'>
                <div className='inner-row'>
                    <span className='title'>
                        שנה:
                    </span>
                    {" " + offer.passedTypeOfInsurance1 && offer.passedTypeOfInsurance1 == 2 ? "X" : offer.sueNumber1}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        שנתיים:
                    </span>
                    {" " + offer.passedTypeOfInsurance2 && offer.passedTypeOfInsurance2 == 2 ? "X" : offer.sueNumber2}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        שלוש שנים:
                    </span>
                    {" " + offer.passedTypeOfInsurance3 && offer.passedTypeOfInsurance3 == 2 ? "X" : offer.sueNumber3}
                </div>
            </div>
            <div className="pass-insurance">
                <div className='inner-row'>
                    <span className='title'>
                        מיקוד:
                    </span>
                    {" " + offer.postalCode ? offer.postalCode : ''}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        תביעות גוף:
                    </span>
                    {" " + offer.bodyClaimsAmount ? offer.bodyClaimsAmount : ''}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        שלילות:
                    </span>
                    {" " + offer.revocationsAmount ? offer.revocationsAmount : ''}
                </div>
            </div>

            <div className="pass-insurance">
                <div className='inner-row'>
                    <span className='title'>
                        כינון.א:
                    </span>
                    {offer.autodirection ? 'כן' : 'לא'}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                         נוהג בשבת:
                    </span>
                    {offer.driveInShabbat ? 'כן' : 'לא'}
                </div>
                <div className='inner-row'>
                    <span className='title'>
                        ח.ת.י:
                    </span>
                    {offer.newForOld ? 'כן' : 'לא'}
                </div>
            </div>
            {/* <div className="cell">
                {offer.routeId!=null? offer.routeId:0}
            </div>
            <div className="cell wide">
            {offer.routeComment}
            </div>
            <div className="cell">
                {this.state.insuranceLabel}
            </div> */}
            <div className="cell-price">
                {offer.comments && offer.comments.length > 0 ? offer.comments[0].slice(0, 10) : ""}
            </div>
            <div className="cell-price">
                {offer.compulsoryPremium != null ? offer.compulsoryPremium : 0}₪
            </div>
            <div className="cell-price">
                {offer.cascoPremium != null ? offer.cascoPremium : 0}₪
            </div>
            <div className="cell-price">
                {ridersSum ? (<>
                    {ridersSum}₪
                </>) : (<>
                    &nbsp;
                </>)}
            </div>
            <div className="cell-price">
                {getNumberOrZero(offer.compulsoryPremium) + getNumberOrZero(offer.cascoPremium) + getNumberOrZero(ridersSum)}₪
            </div>

            <div className="cell button-cell offer-button-cell actions">
                <><div>{OpenProd && OpenProd == offer.id ? "הופק" : ""}</div></>
                {/* <button className="act-btn" onClick={()=>this.toggleBtnMenu()}>פעולות</button> */}
                {/* <div className='act-btn-icon icon menu-hamburger pointer' onClick={()=>this.toggleBtnMenu()}></div> */}
                <DropDownIcon onOptionClick={(action: string, value?: string) => onMenuClick(action, value)} options={optionsList} />
                <div className="icon left-arrow toggle-row"></div>
                {/* {this.state.showBtnOptions && (
                    <ul className="btn-menu">
                        <li className={`pointer ${this.props.emailAddress == '' ? 'hide' : ''}`}
                            onClick={()=>{this.onMenuClick('sendToEmail')}}
                        >
                            שליחה ללקוח מייל
                        </li>
                        <li className="pointer"
                            onClick={()=>{this.onMenuClick('sendToWhatsApp')}}>
                            שליחה בוואטס אפ 
                        </li>
                        {
                            !this.state.hideCreateRiderOption ? (
                        <li className="pointer"
                            onClick={()=>{this.onMenuClick('createRider')}}>
                            יצירת מנוי
                        </li>      
                            ) :
                            (
                                <></>
                            )
                        }   
                    </ul>
                )} */}
            </div>
        </div>
    )
}

export default LeadOfferContent